import { laborHoursConstant } from 'src/redux/actions/constant';

// `pendingById` tracks the rows with a status change in flight so each one can disable
// only its own buttons. `lastSuccessId` / `error` drive the refetch and the error banner.
const intitialstate: any = {
  pendingById: {},
  lastSuccessId: null,
  error: null,
};

export const updateLaborEntryStatusReducer = (state = intitialstate, action: any) => {
  const id = action?.payload?.labourManagementId;

  switch (action.type) {
    case laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_LOADER:
      if (!id) return state;
      return {
        ...state,
        pendingById: { ...state.pendingById, [id]: true },
        error: null,
      };

    case laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_SUCCESS: {
      if (!id) return state;
      const { [id]: _cleared, ...pendingById } = state.pendingById;
      return { ...state, pendingById, lastSuccessId: id, error: null };
    }

    case laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_FAILURE: {
      if (!id) return state;
      const { [id]: _cleared, ...pendingById } = state.pendingById;
      return { ...state, pendingById, error: action.payload?.error };
    }

    case laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_RESET:
      return intitialstate;

    default:
      return state;
  }
};
